export default {
    'ERROR-CREATE-REWARD': {
        'MISSING-MANDATORY-FIELD': {
            actionType: 'toast',
            message: {
                fr: "Un champ obligatoire est manquant.",
                en: "A mandatory field is missing.",
            },
        },
        'MALFORMED-FIELD': {
            actionType: 'toast',
            message: {
                fr: "Un champ est mal formé.",
                en: "A field is malformed.",
            },
        },
        'MISSING-AUDIENCE': {
            actionType: 'toast',
            message: {
                fr: "Veuillez sélectionner au moins un statut, une campagne ou un tag pour l'audience.",
                en: "Please select at least one status, campaign, or tag for the audience.",
            },
        },
        'TEAMSPACE-IDS-MISSING-FOR-ADMIN': {
            actionType: 'toast',
            message: {
                fr: "Veuillez associer le reward à au moins un teamspace.",
                en: "Please associate the reward with at least one teamspace.",
            },
        },
    },
    'ERROR-UPDATE-REWARD': {
        'REWARD-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Reward introuvable.",
                en: "Reward not found.",
            },
            redirectPath: '/',
        },
        'MISSING-AUDIENCE': {
            actionType: 'toast',
            message: {
                fr: "Veuillez sélectionner au moins un statut, une campagne ou un tag pour l'audience.",
                en: "Please select at least one status, campaign, or tag for the audience.",
            },
        },
        'REWARD-NOT-UPDATED': {
            actionType: 'toast',
            message: {
                fr: "Échec de la mise à jour du reward.",
                en: "Failed to update the reward.",
            },
        },
    },
    'ERROR-UPDATE-REWARD-STATUS-ADMIN': {
        'INVALID-STATUS': {
            actionType: 'toast',
            message: {
                fr: "Statut invalide pour le reward.",
                en: "Invalid reward status.",
            },
        },
        'REWARD-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Reward introuvable.",
                en: "Reward not found.",
            },
            redirectPath: '/',
        },
        'REWARD-ALREADY-IN-STATUS': {
            actionType: 'toast',
            message: {
                fr: "Le reward est déjà dans ce statut.",
                en: "The reward is already in this status.",
            },
        },
    },
    'ERROR-GET-AUDIENCE-ADMIN': {
        'USER-DOES-NOT-HAVE-ACCESS-TO-ALL-TEAMSPACES': {
            actionType: 'toast',
            message: {
                fr: "Vous n'avez pas accès à tous les teamspaces sélectionnés.",
                en: "You do not have access to all selected teamspaces.",
            },
        },
    },
};
